import { Auth0Result, Auth0UserProfile, ChangePasswordOptions, CheckSessionOptions, WebAuth } from 'auth0-js';
import { config } from '../../env';
import axios from 'axios';
import { analytics } from 'lib/analytics';
const AUTH0_API = config.AUTH0_API;

const auth0DbConn = AUTH0_API.connection;

export interface SignUpProfile {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  onboardingComplete: boolean;
}

export const webAuth = new WebAuth({
  domain: AUTH0_API.domain,
  clientID: AUTH0_API.client_id,
  audience: AUTH0_API.audience,
  redirectUri: window.location.origin,
  responseType: 'token id_token',
  scope: 'openid profile email user_metadata read:users user_id id'
});

export class Auth0Service {
  async checkSession(options?: CheckSessionOptions) {
    return new Promise<string>((resolve, reject) => {
      webAuth.checkSession(options || {}, (err, res: Auth0Result) => {
        if (err != null) {
          reject(err);
        } else {
          resolve(res.accessToken || '');
        }
      });
    });
  }

  async login(username: string, passowrd: string) {
    const payload = {
      realm: auth0DbConn,
      username: username,
      password: passowrd,
      scope: 'openid profile email read:users user_id id user_metadata'
    };
    return new Promise<any>((resolve, reject) => {
      webAuth.login(payload, (err, res: Auth0Result) => {
        if (err != null) {
          reject(err);
        } else {
          resolve(res);
        }
      });
    });
  }

  logout(returnTo?: string) {
    localStorage.removeItem('userInfo');
    // localStorage.removeItem('access_token');
    // Clear the analytics identity before the redirect so a shared machine
    // doesn't attribute the next user's events to this one.
    analytics.reset();
    webAuth.logout({ returnTo: returnTo || window.location.origin });
    // localStorage.clear();
  }

  async signUp({ email, password, firstName, lastName, onboardingComplete }: SignUpProfile) {
    return new Promise<any>((resolve, reject) => {
      webAuth.signup(
        {
          connection: auth0DbConn,
          email: email,
          password: password,
          userMetadata: {
            firstName,
            lastName,
            onboardingComplete: onboardingComplete ? 'TRUE' : 'FALSE'
          }
        },
        function (err, res) {
          if (err) {
            reject(err);
          } else {
            resolve(res);
          }
        }
      );
    });
  }

  async changePassword(op: ChangePasswordOptions) {
    return new Promise<any>((resolve, reject) => {
      webAuth.changePassword(op, (err, rs) => {
        if (err) {
          reject(err);
        } else {
          resolve(rs);
        }
      });
    });
  }

  async forgotPassword(op: ChangePasswordOptions) {
    return new Promise<any>((resolve, reject) => {
      webAuth.changePassword(op, (err, rs) => {
        if (err) {
          reject(err);
        } else {
          resolve(rs);
        }
      });
    });
  }

  async getUserInfo(token: string): Promise<Auth0UserProfile> {
    return new Promise<Auth0UserProfile>(async (resolve, reject) => {
      try {
        let { data, headers } = await axios.get('https://' + AUTH0_API.domain + '/userinfo', {
          headers: { Authorization: 'Bearer ' + token }
        });
        // x-ratelimit-limit:"10"
        // x-ratelimit-remaining:"8"
        // x-ratelimit-reset:"1682967681"
        if (headers['x-ratelimit-limit'] || headers['x-ratelimit-limit'] == '0') {
          data = { ...data, totalRateLimit: Number(headers['x-ratelimit-limit']) };
        }
        if (headers['x-ratelimit-remaining'] || headers['x-ratelimit-remaining'] == '0') {
          data = { ...data, rateLimitRemaining: Number(headers['x-ratelimit-remaining']) };
        }
        if (headers['x-ratelimit-reset']) {
          data = { ...data, rateLimitResetTime: Number(headers['x-ratelimit-reset']) };
        }
        resolve(data);
      } catch (e) {
        reject(e);
      }

      /*webAuth.client.userInfo(token || '', function (err, user) {
        if (err) {
          reject(err);
        } else {
          resolve(user);
        }
      });*/
    });
  }
}
